
import {SET_GEO} from '../actions/geo';
const geo = (state = {}, action) => {
    switch(action.type)
    {
        case SET_GEO : 
        return action.payload
        default:
        return state;
    }
};

export default geo;


// WEBPACK FOOTER //
// ./src/store/reducers/geo.js